import React from "react";
import { useRecoilValue } from "recoil";
import { getUserAuth } from "../../recoil/selectors";
import { ContentDiv, StyledH2 } from "./TermsOfService.styles";
import { BlankHeader } from "../Header/BlankHeader";

export const TermsOfServicePage: React.FC = () => {
  const auth = useRecoilValue(getUserAuth);

  return (
    <>
      {!auth && <BlankHeader link="https://results.unityscreen.com/" />}
      <br />
      <br />
      <ContentDiv>
        <StyledH2>BILLIONTOONE Provider PORTAL TERMS OF USE </StyledH2>
        <p>
          These BillionToOne Provider Portal Terms of Use (the &quot;Terms&quot;
          or the &quot;Agreement&quot;) are applicable to your access and use of
          the BillionToOne Provider Portal (&quot;Portal&quot;), provided by
          BillionToOne, Inc., our subsidiaries and our affiliates (collectively,
          &quot;BillionToOne,&quot; &quot;we,&quot; or &quot;us&quot;). Your
          access to and use of the Portal are subject to the terms, conditions,
          and notices contained in or referenced by these Terms. Please read
          these Terms carefully. By accessing or using the Portal, you agree to
          comply with and be bound by the Terms. If you do not agree with these
          terms, you are not authorized to use the Portal.
        </p>
        <br />
        <StyledH2>ACCEPTANCE OF TERMS</StyledH2>
        <p>
          By accessing the Portal, you agree to be bound by these Terms. These
          Terms constitute a legally binding agreement between you and
          BillionToOne. If you do not agree to these Terms, you may not use the
          Portal. In the event of any inconsistency between these Terms and any
          written, executed contract between you and BillionToOne, the terms of
          the written contract shall govern.
        </p>
        <StyledH2>ACCESS AND USE</StyledH2>
        <p>
          <b>Eligibility:</b> You must be at least 18 years old or the legal age
          of majority in your jurisdiction to access the Portal. In rendering
          services, you may be asked to electronically sign certain
          documentation. Clicking &quot;I agree&quot; or a similar prompt shall
          constitute your electronic signature and legally bind you to the
          applicable document or provision.
          <br />
          <b>Registration:</b> BillionToOne will set up an account for access to
          the Portal only for a user who is a licensed healthcare provider. You
          may be required to register an account and log in to access the
          Portal. You agree to provide accurate, current, and complete
          information during the registration process and to update such
          information to keep it accurate, current, and complete. If you provide
          any information that is false, inaccurate, or deceptive, as determined
          by BillionToOne in its sole discretion, we may terminate or suspend
          your account and limit your access to the Portal.
          <br />
          <b>User Account:</b> You are responsible for maintaining the
          confidentiality of your account and password and for restricting
          access to your account. You agree to accept responsibility for all
          activities that occur under your account, even in the event not
          authorized by you. You must notify BillionToOne immediately upon any
          breach of security or unauthorized use of your account.
          <br />
          <b>Description of Product:</b> BillionToOne offers various products,
          including but not limited to, access to and use of the Portal. The
          Portal provides Providers the ability to access test results for their
          patients and access additional information made available from
          time-to-time by BillionToOne. Specific features, functions, and
          services provided via the Portal may be changed by BillionToOne
          without notice. Your continued use of the Portal after any changes to
          these Terms will signify your acceptance of such changes.
          <br />
          <b>Use of the Portal:</b> As a condition of use of the Portal, you
          agree to comply with all laws, regulations, and rules applicable to
          your use of and access to the Portal. You agree that you will not
          engage in any action, or otherwise attempt to: breach the security or
          bypass the authentication of the Portal; probe, scan, or test the
          vulnerability of the Portal; engage in or solicit the participation in
          any illegal activity or any action that infringes on the intellectual
          property rights of BillionToOne or others through use of the Portal;
          upload or transmit any virus, malware, or other program or file
          designed to interrupt, corrupt, destroy, or limit the functionality of
          the Portal or any hardware or software; utilize automated means to
          collect information or content from the Portal; provide inaccurate or
          non-current information, including without limitation attempting to
          impersonate or gain access to the information of another individual;
          or otherwise use the Portal in such a fashion that is unlawful,
          violative of these Terms, or intended to access information to which
          you do not have a legal right.
        </p>
        <StyledH2>LIMITATION OF LIABILITY</StyledH2>
        <p>
          IF YOU ARE DISSATISFIED WITH THE PORTAL OR ANY OF BILLIONTOONE&apos;S
          PRACTICES, OR IF YOU OTHERWISE HAVE A DISPUTE WITH BILLIONTOONE, YOUR
          SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USE OF THE PORTAL. IN NO
          EVENT SHALL BILLIONTOONE OR ANY OF ITS AFFILIATES, JOINT VENTURES,
          SERVICE PROVIDERS, AND EMPLOYEES, CONTRACTORS, AGENTS, OFFICERS, AND
          DIRECTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, OR
          CONSEQUENTIAL DAMAGES ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE
          USE OF THE PORTAL, WHETHER BASED ON CONTRACT, TORT, STRICT LIABILITY,
          OR OTHERWISE. THE FOREGOING LIMITATIONS OF LIABILITY ONLY APPLY TO THE
          EXTENT PERMITTED BY APPLICABLE LAW. BILLIONTOONE DOES NOT ASSUME ANY
          RESPONSIBILITY FOR, AND WILL NOT BE LIABLE FOR, ANY DAMAGES TO, OR ANY
          VIRUSES THAT MAY INFECT, YOUR COMPUTER, DEVICE, OR TELECOMMUNICATION
          EQUIPMENT CAUSED BY OR ARISING FROM YOUR ACCESS TO OR USE OF THE
          PORTAL, OR YOUR DOWNLOADING OF ANY INFORMATION OR MATERIALS FROM THE
          PORTAL. IN NO EVENT SHALL BILLIONTOONE&apos;S TOTAL LIABILITY TO YOU
          FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION, WHETHER IN CONTRACT,
          TORT (INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE), OR OTHERWISE EXCEED
          FIFTY UNITED STATES DOLLARS (USD $50).
        </p>
        <StyledH2>COPYRIGHT AND INTELLECTUAL PROPERTY</StyledH2>
        <p>
          <b>Ownership:</b> All content and materials on the Portal, including
          but not limited to text, graphics, logos, and software, are the
          property of BillionToOne or its licensors and are protected by
          intellectual property laws. The coding, look, and feel of the Portal
          provided by BillionToOne are copyrighted by and the property of
          BillionToOne, Inc.
          <br />
          <b>Use Restrictions:</b> You may not reproduce, distribute, modify,
          create derivative works, publicly display, publicly perform, or
          otherwise use any content from the Portal without the express written
          consent of BillionToOne.
        </p>
        <StyledH2>CYBERSECURITY</StyledH2>
        <p>
          <b>Security Measures:</b> BillionToOne employs industry-standard
          security measures to protect the confidentiality and integrity of your
          personal information. However, you acknowledge that no method of
          transmission over the Internet or electronic storage is 100% secure.
          <br />
          <b>Data Breach:</b> In the event of a data breach, BillionToOne will
          promptly notify affected individuals as required by applicable laws
          and regulations.
        </p>
        <StyledH2>GOVERNING LAW</StyledH2>
        <p>
          These Terms shall be governed by and construed in accordance with the
          laws of Delaware, without regard to its conflict of law principles.
        </p>
        <StyledH2>NO WAIVER</StyledH2>
        <p>
          If BillionToOne does not enforce any rights under these Terms at any
          point, it will not be deemed a waiver of any provision or right
          granted by the Terms.
        </p>
        <StyledH2>ENTIRE AGREEMENT</StyledH2>
        <p>
          These Terms represent the entire agreement of the parties with respect
          to the use of the portal.
        </p>
        <StyledH2>CONTACT INFORMATION</StyledH2>
        <p>
          If you have any questions about these Terms, please contact us at
          support@billiontoone.com.
          <br />
          <br />
          By using the BillionToOne Portal, you acknowledge that you have read,
          understood, and agree to be bound by these Terms.
        </p>
        <p>
          <br />
          <b>Last Updated:</b> November 19, 2024
        </p>
      </ContentDiv>
    </>
  );
};
